export default "/images/acfce3a747d9314d17cb2dbeaa94b406.avif";